jQuery(($) => {

    function openInput($element) {
        $element.closest(".m-field").addClass("m-field--focused");
    }

    function maybeCloseInput($element) {
        if ($element.val() !== '') {
            $element.closest(".m-field").addClass("m-field--focused").removeAttr("style");

        } else {
            $element.closest(".m-field").removeClass("m-field--focused");
        }
    }

    if ($('.m-field')[0]) {
        var $inputs       = $(".m-field input[type='text']"),
            $emails       = $(".m-field input[type='email']"),
            $phones       = $(".m-field input[type='tel']"),
            $checkboxes   = $(".m-field input[type='checkbox']"),
            $passwords    = $(".m-field input[type='password']"),
            $radioButtons = $(".m-field input[type='radio']"),
            $textareas    = $(".m-field textarea"),
            $selects      = $(".m-field select");

        // If input or textarea has value, open it
        $inputs.each(function () {
            if ($(this).val() !== '') {
                openInput($(this));
            }
        });

        $passwords.each(function () {
            if ($(this).val() !== '') {
                openInput($(this));
            }
        });

        $emails.each(function () {
            if ($(this).val() !== '') {
                openInput($(this));
            }
        });

        $phones.each(function () {
            if ($(this).val() !== '') {
                openInput($(this));
            }
        });

        $checkboxes.each(function () {
            if ($(this).val() !== '') {
                openInput($(this));
            }
        });

        $radioButtons.each(function () {
            if ($(this).val() !== '') {
                openInput($(this));
            }
        });

        $textareas.each(function () {
            if ($(this).val() !== '') {
                openInput($(this));
            }
        });

        // If input, textarea, or select focused, open it
        $inputs.focus(function () {
            openInput($(this));
        });

        $passwords.focus(function () {
            openInput($(this));
        });

        $emails.focus(function () {
            openInput($(this));
        });

        $phones.focus(function () {
            openInput($(this));
        });

        $checkboxes.focus(function () {
            openInput($(this));
        });

        $radioButtons.focus(function () {
            openInput($(this));
        });

        $textareas.focus(function () {
            openInput($(this));
        });

        $selects.focus(function () {
            openInput($(this));
        });

        // If input, textarea, or select blurred, close if has no value
        $inputs.blur(function () {
            maybeCloseInput($(this));
        });

        $passwords.blur(function () {
            maybeCloseInput($(this));
        });

        $emails.blur(function () {
            maybeCloseInput($(this));
        });

        $textareas.blur(function () {
            maybeCloseInput($(this));
        });

        $selects.blur(function () {
            maybeCloseInput($(this));
        });
    }
});